
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iot",
      function () {
        return require("private-next-pages/iot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iot"])
      });
    }
  